import React, { CSSProperties, useMemo } from "react";

type DisplayGroupNameProps = {
  style?: CSSProperties;
  memberCount?: number;
  name?: string;
  nameAutoGen?: string;
  rightLabel?: string;
  // splitter?: boolean;
};

// const getGroupName = ({
//   members,
//   name,
//   splitter = false,
//   userId,
//   userLastName,
//   userName,
// }: {
//   members: any[];
//   name?: string;
//   splitter?: boolean;
//   userId: string;
//   userLastName: string;
//   userName: string;
// }) => {
//   const list = [...(members || [])].map((item) => ({
//     ...item,
//     ...item.user_obj,
//   }));

//   const getFirstName = (item: any) => {
//     const cleanName = (item.last_name || "").replaceAll(
//       /([.+*?^$()[\]{}|\\])/g,
//       String.raw`\$1`
//     );
//     const reg = new RegExp(cleanName, "g");

//     return item?.full_name?.replace(reg, "")?.trim() || "";
//   };

//   const concatName = list.slice(0, 4).map(getFirstName).join(",");
//   const number = `(${list.length})`;
//   const firstName = getFirstName({
//     full_name: userName,
//     last_name: userLastName,
//   });

//   const friend = list.find((item) => item.id !== Number(userId));

//   let title: any = { full_name: "", name: "", number: "" };

//   switch (list.length - 1) {
//     case 0: {
//       title = { name: "ห้องว่าง" };

//       break;
//     }
//     case 1: {
//       title = {
//         full_name: `${userName}-${friend?.full_name}`,
//         name: friend?.full_name,
//       };

//       break;
//     }
//     case 2:
//     case 3: {
//       title = {
//         name: name || concatName,
//         number,
//       };

//       break;
//     }

//     default: {
//       title = {
//         name: name || `${concatName},...`,
//         number,
//       };
//     }
//   }

//   if (name && splitter) {
//     const reg = / \((\d+)\)$/g;
//     const splitNumber = Number(reg.exec(name)?.[1]);

//     splitNumber === list.length + 1 && (title.name = title.name.replaceAll(reg, ""));
//   }

//   return title;
// };

const DisplayGroupName = React.forwardRef<HTMLDivElement, DisplayGroupNameProps>((props, ref) => {
  const title = useMemo(() => {
    const count = props.memberCount ?? 0;
    const number = count <= 2 ? "" : `(${count})`;
    const name = props.nameAutoGen || "";

    if (!props.name) {
      return { name: name.replaceAll(/ \(\d+\)/g, ""), number };
    }

    return { name: props.name, number };
  }, [props.name, props.nameAutoGen]);

  return (
    <div ref={ref} className="display-name" style={props.style}>
      <>
        <label
          style={{
            fontStyle: props.memberCount === 0 ? "italic" : "",
          }}
        >
          {title.name || props.name}
        </label>
        <label className="right-label"> {props.rightLabel || title.number || ""}</label>
      </>
    </div>
  );
});

DisplayGroupName.displayName = "DisplayGroupName";

export default DisplayGroupName;
